/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Brave_SupportInputs */

const en_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Brave Premium support`)
};

const id_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi dukungan Brave Premium`)
};

const ms_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Brave Premium support`)
};

const ca_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacta amb l'equip d'assistència de Brave Premium`)
};

const cs_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte podporu Brave Premium`)
};

const da_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Brave Premium-kundeservice`)
};

const de_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium-Support kontaktieren`)
};

const et_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Võtke ühendust tasulise Brave'i klienditoega`)
};

const es_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunícate con el equipo de Soporte de Brave Premium`)
};

const fr_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter l’assistance Brave Premium`)
};

const hr_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obratite se podršci za Brave Premium`)
};

const it_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta l'assistenza di Brave Premium`)
};

const lv_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sazināties ar Brave Premium atbalsta dienestu`)
};

const lt_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susisiekti su „Brave Premium“ pagalbos skyriumi`)
};

const hu_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lépjen kapcsolatba a Brave Premium ügyfélszolgálattal`)
};

const nl_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact opnemen met Brave Premium Support`)
};

const nb_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta kontakt med Brave Premiums brukerstøtte`)
};

const pl_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wsparcie Brave Premium`)
};

const pt_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em contato com o Suporte do Brave Premium`)
};

const ro_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactează echipa de asistență Brave`)
};

const sk_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte podporu Brave Premium`)
};

const sl_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrnite se na podporo storitve Brave Premium`)
};

const fi_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä Brave Premium -tukeen`)
};

const sv_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta Brave Premium-support`)
};

const vi_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ với bộ phận hỗ trợ Brave Premium`)
};

const tr_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium destek ile iletişime geçin`)
};

const el_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε με την υποστήριξη Brave Premium`)
};

const bg_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свържи се с поддръжката на Brave Premium`)
};

const ru_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться со службой поддержки Brave`)
};

const sr_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратите се подршци за Brave Premium`)
};

const uk_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зв’язатися із службою підтримки Brave Premium`)
};

const ka_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაუკავშირდით Brave Premium-ის მხარდაჭერის გუნდს`)
};

const hi_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव प्रीमियम सपोर्ट से संपर्क करें`)
};

const th_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อฝ่ายสนับสนุนของ Brave Premium`)
};

const ko_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 프리미엄 지원팀에 문의`)
};

const zh_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系 Brave Premium 支持`)
};

const zh_tw_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`聯絡 Brave 高級版支援`)
};

const ja_contact_brave_support = /** @type {(inputs: Contact_Brave_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premiumサポートに連絡`)
};

/**
* | output |
* | --- |
* | "Contact Brave Premium support" |
*
* @param {Contact_Brave_SupportInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_brave_support = /** @type {((inputs?: Contact_Brave_SupportInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Brave_SupportInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_contact_brave_support(inputs)
	if (locale === "ms") return ms_contact_brave_support(inputs)
	if (locale === "ca") return ca_contact_brave_support(inputs)
	if (locale === "cs") return cs_contact_brave_support(inputs)
	if (locale === "da") return da_contact_brave_support(inputs)
	if (locale === "de") return de_contact_brave_support(inputs)
	if (locale === "et") return et_contact_brave_support(inputs)
	if (locale === "es") return es_contact_brave_support(inputs)
	if (locale === "fr") return fr_contact_brave_support(inputs)
	if (locale === "hr") return hr_contact_brave_support(inputs)
	if (locale === "it") return it_contact_brave_support(inputs)
	if (locale === "lv") return lv_contact_brave_support(inputs)
	if (locale === "lt") return lt_contact_brave_support(inputs)
	if (locale === "hu") return hu_contact_brave_support(inputs)
	if (locale === "nl") return nl_contact_brave_support(inputs)
	if (locale === "nb") return nb_contact_brave_support(inputs)
	if (locale === "pl") return pl_contact_brave_support(inputs)
	if (locale === "pt") return pt_contact_brave_support(inputs)
	if (locale === "ro") return ro_contact_brave_support(inputs)
	if (locale === "sk") return sk_contact_brave_support(inputs)
	if (locale === "sl") return sl_contact_brave_support(inputs)
	if (locale === "fi") return fi_contact_brave_support(inputs)
	if (locale === "sv") return sv_contact_brave_support(inputs)
	if (locale === "vi") return vi_contact_brave_support(inputs)
	if (locale === "tr") return tr_contact_brave_support(inputs)
	if (locale === "el") return el_contact_brave_support(inputs)
	if (locale === "bg") return bg_contact_brave_support(inputs)
	if (locale === "ru") return ru_contact_brave_support(inputs)
	if (locale === "sr") return sr_contact_brave_support(inputs)
	if (locale === "uk") return uk_contact_brave_support(inputs)
	if (locale === "ka") return ka_contact_brave_support(inputs)
	if (locale === "hi") return hi_contact_brave_support(inputs)
	if (locale === "th") return th_contact_brave_support(inputs)
	if (locale === "ko") return ko_contact_brave_support(inputs)
	if (locale === "zh") return zh_contact_brave_support(inputs)
	if (locale === "zh-tw") return zh_tw_contact_brave_support(inputs)
	if (locale === "ja") return ja_contact_brave_support(inputs)
	return en_contact_brave_support(inputs)
});